'use client'

import {useTheme} from "@mui/material";
import {shallowEqual, useSelector} from "react-redux";
import {settingsSelectors} from "@/redux/slices/settings";
import {pxToRem} from "@/components/shared/client/utils";

const useStyles = () => {

    const {fontSize} = useSelector((state) => {
        const fontSize = settingsSelectors.getFontSize(state);
        return {fontSize};
    }, shallowEqual);

    const theme = useTheme();
    return {
        flexContainer: {
            display: "flex"
        },
        defaultStyles: {
            fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
            backgroundColor: theme.palette?.backgrounds?.main,
            color: theme.palette?.texts?.main,
            display: "flex",
            width: "100%"
        },
        appBarStyles: {
            pl: 1,
            pr: 1,
            pt: 1
        },
        appBarIcons: {
            width: "2.5rem",
        },
        appBarIconSize: {
            fontSize: "1.5rem"
        },
        df: {
            display: "flex"
        },
        customCard: {
            display: "block",
            width: "100%",
            borderRadius: "10px",
            pb: 2
        },
        jcc: {
            justifyContent: "center"
        },
        aic: {
            alignItems: "center"
        },
        fdc: {
           flexDirection: "column"
        },
        dashboardModuleHeading: {
            fontSize: "1.1rem",
            fontWeight: "bold",
            width: "100%"
        },
        trendingIcon: {
            up: theme.palette?.texts?.trending?.up,
            down: theme.palette?.texts?.trending?.down
        },
        defaultFontSize: {
            fontSize: pxToRem(fontSize)
        },
        defaultFontFamily: {
            fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
        },
        iconStyles: {
            "svg": {
                fontSize: "1.3rem!important"
            }
        },
        menuItemStyles: {
            ".dnd-sortable-tree_simple_tree-item-collapse_button": {
                outline: "none!important",
                background: `url("data:image/svg+xml;utf8,<svg fill='${theme.palette?.texts?.menuBarIcon}' width='10' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 70 41'><path d='M30.76 39.2402C31.885 40.3638 33.41 40.995 35 40.995C36.59 40.995 38.115 40.3638 39.24 39.2402L68.24 10.2402C69.2998 9.10284 69.8768 7.59846 69.8494 6.04406C69.822 4.48965 69.1923 3.00657 68.093 1.90726C66.9937 0.807959 65.5106 0.178263 63.9562 0.150837C62.4018 0.123411 60.8974 0.700397 59.76 1.76024L35 26.5102L10.24 1.76024C9.10259 0.700397 7.59822 0.123411 6.04381 0.150837C4.4894 0.178263 3.00632 0.807959 1.90702 1.90726C0.807714 3.00657 0.178019 4.48965 0.150593 6.04406C0.123167 7.59846 0.700153 9.10284 1.75999 10.2402L30.76 39.2402Z' /></svg>") no-repeat 50%`
            },
            ".dnd-sortable-tree_simple_handle": {
                background: `url("data:image/svg+xml;utf8,<svg fill='${theme.palette?.texts?.menuBarIcon}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' width='12'><path d='M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z'></path></svg>") no-repeat 50%`
            },
            ".dnd-sortable-tree_simple_tree-item": {
                border: `1px solid ${theme.palette?.backgrounds?.main}`,
                background: theme.palette?.backgrounds?.primary,
            }
        },
        sidebarIconColor: {
            borderRadius: "5px",
            color: theme.palette?.icons?.sidebar,
        },
        sidebarTextColor: {
            color: theme.palette?.texts?.sidebar
        },
        sidebarFocusedTextColor: {
            color: theme.palette?.texts?.sidebarFocused
        },
        muiButton: {
            "button": {
                outline: "none!important",
            }
        }
    }
}

export default useStyles;